module.exports = __webpack_public_path__ + "static/media/2025-AFL-Footy-Lives-Here-Social-Image.973fe2d0.jpg";